import React from 'react';
import { StyledSpan } from './styles';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const Span = ({ children, ...props }: Props) => {
  return <StyledSpan {...props}>{children}</StyledSpan>;
};
